import React from 'react';
import { IdleTimer } from './IdleTimerComponent';
import ga from 'utils/react-google-analytics';
import CreateReactClass from 'create-react-class';

import reactor from 'data/reactor';
import Getters from 'data/getters';
import Actions from 'data/actions';
import SessionStorageManager from 'data/session-storage/session-storage-manager';
import CommonValues from 'resources/common-values';

import popover from 'utils/popover';
import PageHeader from './page-heading';
import PageFooter from './page-footer';
import GlobalSaveDataPrompt from './student-profile/modals/save-data-prompt';
import withRouter from './ComponentWithRouterProp';
import { Outlet } from 'react-router-dom';
import { onUpdate } from '../loaderFunction';

import { DeepCompareComponentShouldUpdateMixin } from 'utils/react';

export default withRouter(
    CreateReactClass({
        displayName: 'app-wrapper',
        mixins: [reactor.ReactMixin, DeepCompareComponentShouldUpdateMixin],

        getInitialState() {
            onUpdate(this.props);
        },

        getDataBindings() {
            return {
                selectedSubject: Getters.runtime.selectedSubject,
                isTransitionInProgress: Getters.runtime.isTransitionInProgress,
                transitionType: Getters.runtime.transitionType,
                transitionToSubject: Getters.runtime.transitionToSubject,
                preferredSubject: Getters.runtime.preferredSubject,
                appLevelCssClassName: Getters.runtime.appLevelCssClassName,
                showHighlights: Getters.runtime.showHighlights,
            };
        },

        componentDidMount() {
            const saveDataRef = CommonValues.sharedModalReferences.saveDataPrompt;
            Actions.runtime.registerModal(saveDataRef, this.refs[saveDataRef].show);
            Actions.runtime.toggleHelpboxPopover();
        },

        onIdle() {
            window.sessionStorage.clear();
            window.location = CommonValues.getLogoutURL(window.location.hostname);
        },

        render() {
            // A module cannot be expanded if the subject doesn't have a test event for the selected term.
            const subjectToDisplay = this.state.transitionToSubject
                ? this.state.transitionToSubject
                : this.state.preferredSubject;

            const subjectName =
                this.state.transitionType == 'selectSubject'
                    ? subjectToDisplay.get('shortName', '').toLowerCase()
                    : this.state.selectedSubject.get('shortName', '').toLowerCase();
            const transitionOut = this.state.isTransitionInProgress ? 'transition-out-modules' : '';
            const highlightsClass = this.state.showHighlights ? 'show-highlights' : 'hide-highlights';
            const classes = `app-container ${subjectName} ${transitionOut} ${this.state.appLevelCssClassName} ${highlightsClass}`;
            const includeAlert = !this.props.location.pathname.includes('family-report');

            return (
                <IdleTimer ref="idleTimer" onIdle={this.onIdle} timeout={1000 * 60 * 15}>
                    <div id="app-content" className={classes} onClick={popover.closePopoverBoxes}>
                        <PageHeader route={this.props.location.pathname} includeAlert={includeAlert} />
                        <Outlet />
                        <PageFooter />
                        <GlobalSaveDataPrompt ref={CommonValues.sharedModalReferences.saveDataPrompt} />
                        <ga.Initializer />
                        <SessionStorageManager />
                    </div>
                </IdleTimer>
            );
        },
    })
);
